import {Component, Input, OnChanges} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {DeviceParamGatewayV3Cron} from "../../../../../../shared/classes/device/type-gateway-v3/device-param-gateway-v3-cron";

@Component({
    selector: 'app-param-cron',
    templateUrl: './param-cron.component.html',
    styleUrls: ['./param-cron.component.css']
})
export class ParamCronComponent implements OnChanges {

    cronForm: FormGroup;
    @Input('deviceParamGatewayV3Cron') deviceParamGatewayV3Cron: DeviceParamGatewayV3Cron;
    @Input('editable') editable: boolean = true;

    constructor() {
    }

    ngOnChanges() {
        if (!this.deviceParamGatewayV3Cron) return;
        if (this.cronForm) return;
        this.cronForm = new FormGroup({

            dataLirisValue: new FormControl(this.getValue(this.deviceParamGatewayV3Cron.liris_data.every)),
            dataLirisUnit: new FormControl(this.getUnit(this.deviceParamGatewayV3Cron.liris_data.every)),
            dataLirisEnable: new FormControl(this.getEnable(this.deviceParamGatewayV3Cron.liris_data.enable)),

            syncLirisValue: new FormControl(this.getValue(this.deviceParamGatewayV3Cron.liris_sync_time.every)),
            syncLirisUnit: new FormControl(this.getUnit(this.deviceParamGatewayV3Cron.liris_sync_time.every)),
            syncLirisEnable: new FormControl(this.getEnable(this.deviceParamGatewayV3Cron.liris_sync_time.enable)),

            postLirisFilesFromGatewayValue: new FormControl(this.getValue(this.deviceParamGatewayV3Cron.post_liris_files_from_gateway.every)),
            postLirisFilesFromGatewayUnit: new FormControl(this.getUnit(this.deviceParamGatewayV3Cron.post_liris_files_from_gateway.every)),
            postLirisFilesFromGatewayEnable: new FormControl(this.getEnable(this.deviceParamGatewayV3Cron.post_liris_files_from_gateway.enable)),


            getGatewayConfigByUidValue: new FormControl(this.getValue(this.deviceParamGatewayV3Cron.get_gateway_config_by_uid.every)),
            getGatewayConfigByUidUnit: new FormControl(this.getUnit(this.deviceParamGatewayV3Cron.get_gateway_config_by_uid.every)),
            getGatewayConfigByUidEnable: new FormControl(this.getEnable(this.deviceParamGatewayV3Cron.get_gateway_config_by_uid.enable)),

        })
    }

    public setDeviceWithForm() {
        if (this.cronForm.value.dataLirisValue && this.cronForm.value.dataLirisUnit) {
            this.deviceParamGatewayV3Cron.liris_data.every = this.cronForm.value.dataLirisValue.toString() + this.cronForm.value.dataLirisUnit;
        }
        this.deviceParamGatewayV3Cron.liris_data.enable = this.cronForm.value.dataLirisEnable === true ? 1 : 0;

        if (this.cronForm.value.syncLirisValue && this.cronForm.value.syncLirisUnit) {
            this.deviceParamGatewayV3Cron.liris_sync_time.every = this.cronForm.value.syncLirisValue.toString() + this.cronForm.value.syncLirisUnit;
        }
        this.deviceParamGatewayV3Cron.liris_sync_time.enable = this.cronForm.value.syncLirisEnable === true ? 1 : 0;

        if (this.cronForm.value.postLirisFilesFromGatewayValue && this.cronForm.value.postLirisFilesFromGatewayUnit) {
            this.deviceParamGatewayV3Cron.post_liris_files_from_gateway.every = this.cronForm.value.postLirisFilesFromGatewayValue.toString() + this.cronForm.value.postLirisFilesFromGatewayUnit;
        }
        this.deviceParamGatewayV3Cron.post_liris_files_from_gateway.enable = this.cronForm.value.postLirisFilesFromGatewayEnable === true ? 1 : 0;

        if (this.cronForm.value.getGatewayConfigByUidValue && this.cronForm.value.getGatewayConfigByUidUnit) {
            this.deviceParamGatewayV3Cron.get_gateway_config_by_uid.every = this.cronForm.value.getGatewayConfigByUidValue.toString() + this.cronForm.value.getGatewayConfigByUidUnit;
        }
        this.deviceParamGatewayV3Cron.get_gateway_config_by_uid.enable = this.cronForm.value.getGatewayConfigByUidEnable === true ? 1 : 0;
    }

    public getValue(value: string): number {
        if (JSON.stringify(value) !== undefined) return parseInt(value.slice(0, -1));
        return 0;
    }

    public getUnit(value: string): string {
        if (JSON.stringify(value) !== undefined) return value.charAt(value.length - 1);
        return '';
    }

    public getEnable(value: number) {
        if (JSON.stringify(value) !== undefined) return value === 1;
        return false;
    }


}
